import { CalendarManager, Splits, SplitsCalendarParams } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { injectLogos } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchStockSplits = (
  session: Session,
  params: SplitsCalendarParams = {},
  injectTickersLogos = true,
  pageSize = 100,
): Promise<Splits[]> => {
  const query: SplitsCalendarParams = { ...params, dateSearchField: 'ex', pageSize };
  return session
    .getManager(CalendarManager)
    .getCalendarData('splits', query)
    .then(res => {
      if (res.ok && res.ok.length) {
        const sortedData = res.ok.sort((a, b) => {
          const dateA = a.date_ex ? new Date(a.date_ex).getTime() : 0;
          const dateB = b.date_ex ? new Date(b.date_ex).getTime() : 0;
          return dateA - dateB;
        });
        return injectTickersLogos ? injectLogos(sortedData, session) : sortedData;
      }
      return [];
    })
    .catch(error => {
      logCalendarFetchFailure('stock-splits', error);
      return [];
    });
};

export { fetchStockSplits };
